import { render, staticRenderFns } from "./BtnEntragaManual.vue?vue&type=template&id=2e0aea44"
import script from "./BtnEntragaManual.vue?vue&type=script&lang=js"
export * from "./BtnEntragaManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports